/* Nava Interior – udvidet kurv: fri fragt-bjælke, anbefalinger, subtotal/fragt/levering */
(function () {
  if (window.__nciCart) return;
  window.__nciCart = true;

  var EU = ['AT','BE','BG','HR','CY','CZ','DE','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var DAYS = ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'];
  var MONTHS = ['januar','februar','marts','april','maj','juni','juli','august','september','oktober','november','december'];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cart = null, recs = [], recsFor = null, busy = false;

  function rate() { var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return r > 0 ? r : 1; }
  function country() { return (window.Shopify && Shopify.country) || 'DK'; }
  function zone() {
    var c = country();
    if (c === 'DK') return { free: 50000, fee: 3900, delivery: true };
    if (EU.indexOf(c) > -1) return { free: 100000, fee: 9900, delivery: false };
    return { free: null, fee: 29900, delivery: false };
  }
  function money(cents) {
    var fmt = (window.theme && theme.moneyFormat) || 'kr {{amount_with_comma_separator}}';
    var v = (Math.round(cents) / 100).toFixed(2);
    var parts = v.split('.');
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_with_comma_separator') return dot;
      if (k === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return comma;
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  /* Leveringsdatoer: hverdag før kl. 12 = 1–2 hverdage, ellers 2–3 hverdage */
  function cphNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { date: new Date(+p.year, +p.month - 1, +p.day), hour: +p.hour % 24 };
  }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function deliveryText() {
    var now = cphNow(), w = now.date.getDay();
    var early = w !== 0 && w !== 6 && now.hour < 12;
    var a = addBusinessDays(now.date, early ? 1 : 2), b = addBusinessDays(now.date, early ? 2 : 3);
    var left = cap(DAYS[a.getDay()]) + ' ' + a.getDate() + '.' + (a.getMonth() !== b.getMonth() ? ' ' + MONTHS[a.getMonth()] : '');
    return left + ' – ' + DAYS[b.getDay()] + ' ' + b.getDate() + '. ' + MONTHS[b.getMonth()];
  }

  function els(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function renderShip() {
    var z = zone(), r = rate();
    els('[data-nci-ship]').forEach(function (el) {
      if (!cart || !cart.item_count || !z.free) { el.hidden = true; return; }
      el.hidden = false;
      var free = Math.round(z.free * r), total = cart.total_price;
      var pct = Math.min(100, Math.round(total / free * 100));
      var txt = total >= free
        ? 'Tillykke! Du har fået <strong>gratis forsendelse</strong>'
        : 'Køb for kun <strong>' + money(free - total) + '</strong> mere, og få gratis forsendelse';
      el.innerHTML = '<p class="nci-ship__text">' + txt + '</p><div class="nci-ship__bar"><span style="width:' + pct + '%"></span></div>';
    });
  }

  function renderSummary() {
    var z = zone(), r = rate();
    els('[data-nci-summary]').forEach(function (el) {
      if (!cart || !cart.item_count) { el.innerHTML = ''; return; }
      var isFree = z.free && cart.total_price >= Math.round(z.free * r);
      var html = '<div class="nci-row"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<div class="nci-row"><span>Fragt</span><span>' + (isFree ? 'Gratis' : money(Math.round(z.fee * r))) + '</span></div>';
      if (z.delivery) html += '<div class="nci-row"><span>Forventet levering</span><span>' + deliveryText() + '</span></div>';
      el.innerHTML = html;
    });
  }

  function renderUpsell() {
    var inCart = {};
    (cart && cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; });
    var list = recs.filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 8);
    els('[data-nci-upsell]').forEach(function (el) {
      if (!cart || !cart.item_count || !list.length) { el.hidden = true; el.innerHTML = ''; return; }
      el.hidden = false;
      el.innerHTML = '<p class="nci-upsell__title">More to love</p><div class="nci-upsell__track">' + list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        var single = p.variants && p.variants.length === 1 && v;
        var btn = single
          ? '<button type="button" class="nci-card__add" data-nci-add="' + v.id + '" aria-label="Tilføj ' + esc(p.title) + ' til kurv">+</button>'
          : '<a class="nci-card__add" href="' + esc(p.url) + '" aria-label="Vælg variant af ' + esc(p.title) + '">+</a>';
        return '<div class="nci-card"><a class="nci-card__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="nci-card__info"><a class="nci-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="nci-card__price">' + money(p.price) + '</span></div>' + btn + '</div>';
      }).join('') + '</div>';
    });
  }

  function renderAll() { renderShip(); renderUpsell(); renderSummary(); }

  function getJSON(url) { return window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }

  /* Kun de produkter, I selv har valgt i Search & Discovery (komplementære produkter) */
  function loadRecs() {
    if (!cart || !cart.items.length) { recs = []; recsFor = null; return Promise.resolve(); }
    var ids = [];
    cart.items.forEach(function (i) { if (ids.indexOf(i.product_id) < 0) ids.push(i.product_id); });
    ids = ids.slice(0, 6);
    var key = ids.join(',');
    if (recsFor === key) return Promise.resolve();
    recsFor = key;
    return Promise.all(ids.map(function (pid) {
      return getJSON(root + 'recommendations/products.json?limit=10&intent=complementary&product_id=' + pid).catch(function () { return { products: [] }; });
    })).then(function (res) {
      var seen = {}, out = [];
      res.forEach(function (r) { (r.products || []).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } }); });
      recs = out;
    });
  }

  function refresh() {
    return getJSON(root + 'cart.js').then(function (c) { cart = c; renderAll(); return loadRecs(); }).then(renderUpsell).catch(function () {});
  }
  var t;
  function refreshSoon() { clearTimeout(t); t = setTimeout(refresh, 150); }

  /* Opdater temaets egne linjer efter vi selv har lagt i kurv */
  function syncThemeItems() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    setTimeout(function () {
      var rows = document.querySelectorAll('[data-line-items] .cart__items__row:not(.cart__items--blankstate .cart__items__row)').length;
      if (cart && rows >= cart.items.length) return;
      window.fetch(root + '?sections=api-cart-items,api-cart-subtotal').then(function (r) { return r.json(); }).then(function (s) {
        var tmp = document.createElement('div');
        [['api-cart-items', '[data-line-items]'], ['api-cart-subtotal', '[data-cart-subtotal]']].forEach(function (pair) {
          if (!s[pair[0]]) return;
          tmp.innerHTML = s[pair[0]];
          var c = tmp.querySelector('[data-api-content]');
          if (c) els(pair[1]).forEach(function (el) { el.innerHTML = c.innerHTML; });
        });
        els('[data-cart-final]').forEach(function (el) { el.textContent = money(cart.total_price) + ' ' + (cart.currency || ''); });
        els('[data-cart-empty]').forEach(function (el) { el.classList.add('cart--hidden'); });
        els('[data-cart-bottom]').forEach(function (el) { el.classList.remove('cart--hidden'); });
      }).catch(function () {});
    }, 900);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nci-add]');
    if (!b || busy) return;
    e.preventDefault();
    busy = true; b.classList.add('is-loading');
    window.fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-nci-add'), quantity: 1 }] })
    }).then(function () { return refresh(); }).then(syncThemeItems)
      .finally(function () { busy = false; b.classList.remove('is-loading'); });
  });

  /* Lyt efter alle kurvændringer (tema, apps, os selv) */
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(refreshSoon, refreshSoon);
    } catch (e) {}
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (/\/cart\/(add|change|update|clear)/.test(u || '')) this.addEventListener('loadend', refreshSoon);
    return origOpen.apply(this, arguments);
  };
  ['theme:cart:change', 'theme:cart:refresh', 'cart:refresh', 'theme:drawer:open'].forEach(function (ev) {
    document.addEventListener(ev, refreshSoon);
  });

  /* Hvis temaet gen-renderer skuffen, så tegn igen fra cache */
  var mo = new MutationObserver(function () {
    var need = els('[data-nci-summary]').some(function (el) { return cart && cart.item_count && !el.innerHTML; });
    if (need) renderAll();
  });
  function start() {
    var d = document.getElementById('drawer-cart');
    if (d) mo.observe(d, { childList: true, subtree: true });
    refresh();
    setInterval(function () { if (cart && cart.item_count) renderSummary(); }, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* Produktside: hent op til 10 komplementære produkter (temaet kan max 3) */
  function sharpen(root) {
    Array.prototype.forEach.call(root.querySelectorAll('img'), function (img) {
      ['src', 'srcset', 'data-src', 'data-srcset'].forEach(function (a) {
        var v = img.getAttribute(a);
        if (v) img.setAttribute(a, v.replace(/width=\d+/g, 'width=500'));
      });
    });
  }
  function moreComplementary() {
    els('product-complimentary[data-url]').forEach(function (el) {
      var url = el.dataset.url.replace(/([?&]limit=)\d+/, function (m, p) { return p + '10'; });
      window.fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var c = tmp.querySelector('[data-api-content]');
        if (!c || !c.innerHTML.trim()) return;
        var count = c.querySelectorAll('.quickview').length;
        function apply() {
          if (el.querySelectorAll(':scope > .quickview').length >= count) return;
          el.innerHTML = c.innerHTML;
          sharpen(el);
          var holder = el.closest('[data-product-complimentary-loaded]');
          if (holder) holder.classList.remove('js-unloaded');
        }
        apply();
        new MutationObserver(function () { apply(); }).observe(el, { childList: true });
      }).catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moreComplementary); else moreComplementary();
})();
